import { marked } from "marked";
import privacyPolicy from "~/privacy-policy";

export function meta() {
  return [
    {
      title: "Privacy Policy — Jiwe eSports",
    },
  ];
}

export default function TermsOfService() {
  return (
    <main className="lg:p-12 lg:pl-0 box-border">
      <div className="min-h-[85vh]">
        <div className="min-h-[50vh] pt-24 px-5 lg:pt-0">
          <div
            className="relative -ml-5 py-6 bg-jiwe-dark-blue-translucent lg:bg-[transparent]"
            style={{
              width: "calc(100% + 2.5rem)",
            }}
          >
            <div className="slanting absolute left-0 border-t-jiwe-dark-blue-translucent w-full -top-4 border-t-[1rem] border-r-[transparent] border-r-[100vw] rotate-180 lg:hidden" />
            <h1 className="uppercase text-jiwe-dark-blue lg:text-[#000] dark:lg:text-grey-light dark:text-[#FDFDFD] font-black lg:font-bold text-3xl text-center lg:text-left lg:text-6xl -mt-3">
              Jiwe Esports
              <br />
              Privacy Policy
            </h1>
            <div className="slanting absolute left-0 border-t-jiwe-dark-blue w-full bottom-0 border-t-[1rem] border-r-[transparent] border-r-[100vw] rotate-180 lg:hidden" />
          </div>
          <div className="w-14 my-12 border-t-[.5px] border-t-divider dark:border-t-divider-dark" />
          <div
            className="text-sm text-text dark:text-grey-light prose dark:prose-invert max-w-sm md:max-w-3xl 2xl:prose-xl"
            dangerouslySetInnerHTML={{
              __html: marked(privacyPolicy),
            }}
          />
        </div>
      </div>
    </main>
  );
}
